import articleTypes from "astrid-firestore/src/api/articles/constants/articleTypes";

import getDocumentData from "../../src/utils/getDocumentData";

import createArticleDelivery from "./createArticleDelivery";
import createAudioArtifact from "./createAudioArtifact";
import createChannels from "./createChannels";
import createCover from "./createCover";
import createDocumentIdAndRef from "./createDocumentIdAndRef";

export default async function createAudiobook({ api, env }, { production, publisher, commonArticleData }) {
	const { id, ref } = createDocumentIdAndRef({ api, env }, { collection: "articles" });
	const article = {
		id,
		ref,
		type: articleTypes.AUDIOBOOK,
		name: production.title,
		isbn: production.isbn,
		synopsis: production.synopsis || "",
		bokgruppe: production.bokgruppe?.toString() || null,
		...commonArticleData,
	};
	const cover = await createCover({ api, env }, { img: production.img });
	const coverThumb = await createCover({ api, env }, { img: production.imgThumb });
	const artifact = await createAudioArtifact({ api, env }, { production, article });
	const duration = artifact?.files?.reduce?.((sum, file) => sum + file.duration, 0) || 0;

	const fullPublisherDocRef = api.convertFromLiveToStage
		? api.stage.db.collection("organizations").doc(publisher.id)
		: api[env].db.collection("organizations").doc(publisher.id);
	const fullPublisherDoc = await getDocumentData(fullPublisherDocRef);
	const { channels, channelIds } = await createChannels(
		{ api, env },
		{ article, fullPublisherDoc, production, articleType: "total" },
	);
	const delivery = createArticleDelivery({ channels, channelIds });

	return {
		...article,
		artifact,
		cover,
		coverThumb,
		duration,
		channels,
		channelIds,
		delivery,
	};
}
